import { Box, Typography } from "@mui/material";

export const AmikFooter = () => {
  return (
    <Box
      component="footer"
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        py: 0.75,
        px: 2,
        textAlign: "right",
        borderTop: "1px solid rgba(0, 0, 0, 0.1)",
        backgroundColor: "#fff",
        boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.06)",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          fontSize: { xs: "0.6rem", sm: "0.65rem" },
          mb: 0.25,
          display: "block",
        }}
      >
        Powered by{" "}
        
          Amik Tech
      </Typography>
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          fontSize: { xs: "0.55rem", sm: "0.6rem" },
          display: "block",
        }}
      >
        © {new Date().getFullYear()} Amik Tech. All Rights Reserved.
      </Typography>
    </Box>
  );
};

